import CalendarEventDetail from './modal/calendar_event_detail';
import CalendarReminderDetail from './modal/reminder_details';
import { TransformedCalendarEventObject } from '../../params/redux/calendar';
import { useState } from 'react';
import { Box, Typography } from '@mui/material';

interface CalendarEventProps {
    event: TransformedCalendarEventObject;
}

const CalendarMeetingComponent = ({ event }: CalendarEventProps) => {
    const [selectedEvent, setSelectedEvent] = useState<null | TransformedCalendarEventObject>(null);
    const [showReminder, setShowReminder] = useState<null | TransformedCalendarEventObject>(null);

    const handleClose = () => {
        setSelectedEvent(null);
        setShowReminder(null);
    };

    return (
        <>
            <Box bgcolor={event.color} display="flex" alignItems="center" onClick={() => (event.type === 'event' ? setSelectedEvent(event) : setShowReminder(event))}>
                <Typography variant="body2" lineHeight="1rem">
                    {/* {event.start && event.type === 'event' && formatTime(
                        event.start instanceof Date ? event.start.toISOString() : event.start,
                        {
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: true
                        }
                    )} */}
                    <strong>{` ${event.title}`}</strong>
                </Typography>
            </Box>
            {selectedEvent?.id === event.id && event.type === 'event' && <CalendarEventDetail open={selectedEvent?.id === event.id} onClose={handleClose} selectedEvent={event} />}
            {showReminder?.id === event.id && event.type === 'reminder' && <CalendarReminderDetail open={showReminder?.id === event.id} onClose={handleClose} selectedEvent={event} />}
        </>
    );
};

export default CalendarMeetingComponent;
